export enum PlaybackEnum {
  PLAYING = 'PLAYING',
  STOP = 'STOP',
  PAUSE = 'PAUSE',
}
